module.exports = __webpack_public_path__ + "static/media/warning-filled.eb1737de.svg";